import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/Dialog';

interface UnregisterConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
  /**
   * Why the last attempt failed, shown inside the open dialog (`role="alert"`) so
   * it can be retried. A member's unregister toasts instead, so omits it.
   */
  error?: string;
}

/**
 * Confirmation guard before unregistering from an event (MYN-52 UX decision:
 * unregister requires confirmation; register is one-click). Reused for a
 * remembered non-member (FR-289), whose failures show inline via `error`.
 */
export function UnregisterConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending,
  error,
}: UnregisterConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title="Cancel registration?"
      description="Are you sure you want to unregister from this event? You can re-register any time before registration closes."
      showCloseButton={false}
      footer={
        <>
          {error && (
            <p role="alert" className="text-sm text-red">
              {error}
            </p>
          )}
          <Button variant="primary" onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Unregistering…' : 'Yes, unregister'}
          </Button>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            Keep my spot
          </Button>
        </>
      }
    />
  );
}
